import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const AccountingTransactionSchema = withDefaults({
  type: 'accounting-transaction',
  fields: [
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'transactionDate',
    },
    {
      kind: 'attribute',
      name: 'isCheck',
    },
    {
      kind: 'attribute',
      name: 'checkNumber',
    },
    {
      kind: 'attribute',
      name: 'creditor',
    },
    {
      kind: 'attribute',
      name: 'creditorAddress',
    },
    {
      kind: 'attribute',
      name: 'servicer',
    },
    {
      kind: 'attribute',
      name: 'employeeName',
    },
    {
      kind: 'belongsTo',
      name: 'accountingPayment',
      type: 'accounting-payment',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'accountingInvoice',
      type: 'accounting-invoice',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'accountingLineItem',
      type: 'accounting-line-item',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default AccountingTransactionSchema;
